import { render, staticRenderFns } from "./links-settings.vue?vue&type=template&id=591e3ba3"
import script from "./links-settings.vue?vue&type=script&lang=js"
export * from "./links-settings.vue?vue&type=script&lang=js"
import style0 from "./links-settings.vue?vue&type=style&index=0&id=591e3ba3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports